import React, { useMemo } from 'react';
import ContainerHeader from '../components/ContainerHeader';
import {
  ColumnDirective,
  ColumnsDirective,
  ContextMenu,
  Edit,
  Filter,
  GridComponent,
  Group,
} from '@syncfusion/ej2-react-grids';
import { Inject, Page, Sort, Search, Toolbar } from '@syncfusion/ej2-react-grids';
import { Button } from '@mui/material';
import { DebugBoundary } from '../Dockets';
import useGeoFencing from './CustomHooks/useGeoFencing';
import AddGeoFenceDialog from './components/AddGeoFenceDialog';
import { Delete } from '@mui/icons-material';

const GeoFencing = props => {
  const pageSettings = useMemo(
    () => ({
      pageSize: 30,
      pageSizes: [5, 10, 20, 30, 40],
    }),
    [],
  );
  const filterSettings = {
    type: 'Excel',
  };
  const toolbarOptions = ['Search'];

  const {
    geoFenceData,
    isOpen,
    openGeoFenceModal,
    handleDelete,
    handleEdit,
    closeGeoFenceModal,
    geoFenceForm,
    updateGeoFenceForm,
    handleMapClick,
    handleSave,
    siteAssessments,
    contracts,
    center,
    zoom,
    fetchSiteForContract,
    fetchContractsForSite,
    resetContractsToAll,
    resetSiteAssessmentsToAll,
    handleSiteChange,
    handleContractChange,
    pinData,
    activePin,
    setActivePin,
  } = useGeoFencing({ isMapLoaded: false });

  const handleActionBegin = args => {
    if (args.requestType === 'beginEdit' || args.requestType === 'save') {
      setTimeout(() => {
        // safe state updates here
      }, 0);
    }
  };

  function editLink(props) {
    return (
      <Button
        key={`${props.id}_site`}
        style={{ color: 'blue', fontWeight: 'bold', width: '100%' }}
        onClick={() => handleEdit(props)}>
        {props.id}
      </Button>
    );
  }

  function actionTemplate(props) {
    return (
      <Button size="small" color="error" onClick={() => handleDelete(props.id)} style={{ minWidth: 0, padding: '4px' }}>
        <Delete />
      </Button>
    );
  }

  return (
    <div className="app-wrapper siteWrapper">
      <ContainerHeader match={props.match} title={'GeoFencing'} />
      <Button size="small" variant="contained" color="primary" style={{ marginLeft: '10px' }} onClick={openGeoFenceModal}>
        + Add New GeoFence
      </Button>
      <div style={{ height: 'calc(100vh - 145px)', width: '100%' }}>
        <DebugBoundary>
          <GridComponent
            dataSource={geoFenceData}
            filterSettings={filterSettings}
            allowPaging={true}
            pageSettings={pageSettings}
            allowSorting={true}
            allowTextWrap={true}
            allowResizing={true}
            allowMultiSorting={true}
            allowReordering={true}
            allowFiltering={true}
            style={{
              minHeight: 'auto !important',
            }}
            actionBegin={handleActionBegin}
            height="100%"
            toolbar={toolbarOptions}>
            <ColumnsDirective>
              <ColumnDirective
                field="id"
                headerText="Edit Link"
                width="80"
                textAlign="Left"
                template={editLink}
                isPrimaryKey={true}
              />
              <ColumnDirective field="siteAssessmentID" headerText="Site Assessment ID" width="100" />
              <ColumnDirective field="contractUniqueID" headerText="Contract ID" width="100" />
              <ColumnDirective field="geofenceType" headerText="Geofence Type" width="100" />
              <ColumnDirective field="locationName" headerText="Name" width="100" />
              <ColumnDirective field="latitude" headerText="Latitude" width="100" />
              <ColumnDirective field="longitude" headerText="Longitude" width="100" />
              <ColumnDirective field="radius" headerText="Radius" width="100" />
              <ColumnDirective headerText="Action" width="80" textAlign="Center" template={actionTemplate} />
            </ColumnsDirective>
            <Inject services={[Page, Sort, Filter, Group, Search, Toolbar, ContextMenu]} />
          </GridComponent>
        </DebugBoundary>
      </div>

      <AddGeoFenceDialog
        isOpen={isOpen}
        closeGeoFenceModal={closeGeoFenceModal}
        geoFenceForm={geoFenceForm}
        updateGeoFenceForm={updateGeoFenceForm}
        handleMapClick={handleMapClick}
        handleSave={handleSave}
        siteAssessments={siteAssessments}
        contracts={contracts}
        center={center}
        zoom={zoom}
        fetchSiteForContract={fetchSiteForContract}
        fetchContractsForSite={fetchContractsForSite}
        resetContractsToAll={resetContractsToAll}
        resetSiteAssessmentsToAll={resetSiteAssessmentsToAll}
        handleSiteChange={handleSiteChange}
        handleContractChange={handleContractChange}
        pinData={pinData}
        activePin={activePin}
        setActivePin={setActivePin}
      />
    </div>
  );
};

export default GeoFencing;
